export default "__VITE_PUBLIC_ASSET__d6100fa1__"